import type { SVGProps } from 'react'

export function LogoMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 100 100" role="img" aria-label="Roofora" {...props}>
      <rect x="6" y="6" width="88" height="88" rx="20" fill="#f3efe6" stroke="#142430" strokeWidth={2.5} />
      <g transform="rotate(-6 44 30)">
        <rect x="18" y="16" width="50" height="30" rx="2" fill="#2f7480" stroke="#142430" strokeWidth={2} />
        <line x1="34.67" y1="16" x2="34.67" y2="46" stroke="#f3efe6" strokeWidth={1.6} />
        <line x1="51.33" y1="16" x2="51.33" y2="46" stroke="#f3efe6" strokeWidth={1.6} />
        <line x1="18" y1="31" x2="68" y2="31" stroke="#f3efe6" strokeWidth={1.6} />
        <polygon points="20,18 34,18 26,30 20,30" fill="#9bd1d6" opacity={0.65} />
      </g>
      <line x1="68" y1="46" x2="34" y2="80" stroke="#e2a431" strokeWidth={10} strokeLinecap="round" />
      <rect x="55" y="30" width="34" height="15" rx="5" fill="#e2a431" stroke="#142430" strokeWidth={2} transform="rotate(45 72 37.5)" />
      <circle cx="34" cy="78" r="11" fill="#142430" stroke="#f3efe6" strokeWidth={1.5} />
      <rect x="26" y="76" width="16" height="3" rx="1.5" fill="#f3efe6" />
    </svg>
  )
}
